import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import task from './components/task'
import TaskEdit from './components/TaskEdit'
import attachment from './components/Attachment'
import taskTab from './components/taskTab'
import addOn from './components/AddOns'
import trainingTab from './components/trainingTab'
import PageNotFound from './views/PageNotFound'
import Reconcile from './views/commissions/Reconcile'
import ReconcileFile from './views/commissions/ReconcileFile'
import Login from './views/auth/Login'
import OfficeMessage from './views/office/message/OfficeMessage'
import FileCreateForm from './views/commissions/partials/FileCreateForm'
import MergeConfirm from './views/commissions/MergeConfirm'
import Email from './components/Email'
import PaymentMethod from './components/PaymentMethod'
import BillNow from './components/BillNow'
import CheckNumber from './components/CheckNumber'
import FinanceContract from './components/FinanceContract'
import WelcomeModal from './components/Home/WelcomeModal'
import AgencyBuzz from "./components/AgencyBuzz";
import SignUp from "./components/BackOffice/SignUp";

Vue.use(Router)

export default new Router({
  base: '/',
  mode: 'history',
  linkActiveClass: 'am-main-tab-current',

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/task',
      name: 'task',
      component: task
    },
    {
      path: '/TaskEdit',
      name: 'TaskEdit',
      component: TaskEdit
    },
    {
      path: '/taskTab/:id',
      name: 'taskTab',
      component: taskTab,
      props: true
    },
    {
      path: '/auth/login',
      name: 'auth.login',
      component: Login
    },
    {
      path: '/commissions/reconcile',
      name: 'commissions.reconcile.main',
      component: Reconcile,
      props: route => {
        return {
          status: Number.parseInt(route.query.status) || null
        }
      }
    },
    {
      path: '/commissions/reconcile/:id',
      name: 'commissions.reconcile.file',
      component: ReconcileFile,
      props: true
    },
    {
      path: '/commissions/create',
      name: 'commissions.create',
      component: FileCreateForm
    },
    {
      path: '/commissions/merge',
      name: 'commissions.merge',
      component: MergeConfirm,
      props: true
    },
    {
      path: '*',
      component: PageNotFound
    },
    {
      path: '/office/message',
      name: 'office.message',
      component: OfficeMessage
    },

    {
      path: '/training/:id?',
      name: 'trainingTab',
      component: trainingTab,
      props: true
    },

    {
      path: '/attachment',
      name: 'attachment',
      component: attachment
    },

    {
      path: '/email',
      name: 'email',
      component: Email
    },

    {
      path: '/addOn',
      name: 'addOn',
      component: addOn
    },

    {
      path: '/paymentMethod',
      name: 'paymentMethod',
      component: PaymentMethod
    },

    {
      path: '/billNow',
      name: 'billNow',
      component: BillNow
    },

    {
      path: '/checkNumber',
      name: 'checkNumber',
      component: CheckNumber
    },
    {
      path: '/welcome',
      name: 'Welcome',
      component: WelcomeModal
    },
    {
      path: '/financeContract',
      name: 'financeContract',
      component: FinanceContract
    },
    {
      path: '/agencyBuzz',
      name: 'agencyBuzz',
      component: AgencyBuzz,
      props: true
    },
    {
      path: '/signUp',
      name: 'signUp',
      component: SignUp,
    },
  ]
})
